///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, Input } from '@angular/core';
import { UserAuthorities } from '../../../../services/user/user-authorities';
import { SuiNotification } from '@siklu/sui-lib/infrastructure';
import { GtthSessionNavigationModel } from '../session-navigation.model';
import { Router } from '@angular/router';

@Component({
    selector: 'winde-user-session-restoring-content',
    styles: [
        `
            :host {
                font-size: medium;
            }

            .navigation-item {
                margin: 5px;
            }
        `
    ],
    template: `
        <strong>Do you want to return to your last activity?</strong>
        @for (navigation of notification.data; track navigation.navigationCommand) {
            <li class="navigation-item">
                <a href="javascript:void(0);" (click)="router.navigateByUrl(navigation.navigationCommand)"
                    >{{ navigation.moduleName | translate }}{{ navigation.projectName ? " '" + navigation.projectName + "'" : ''
                    }}<span *windeHasAnyAuthority="userAuthorities.ALL_SIKLU">{{
                        navigation.companyName ? ", company '" + navigation.companyName + "'" : ''
                    }}</span>
                </a>
            </li>
        }
    `,
    standalone: false
})
export class UserSessionRestoringContentComponent {
    @Input() notification: SuiNotification<GtthSessionNavigationModel[]>;
    public userAuthorities = UserAuthorities;

    constructor(public readonly router: Router) {}
}
